import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { State } from '../../store/reducers';

/** Bottom area of the main dashboard */
@Component({
  selector: 'app-bottom-panel',
  templateUrl: './bottom-panel.component.html',
  styleUrls: ['./bottom-panel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BottomPanelComponent implements OnInit {
  public colorScheme = {
    domain: ['#FFFFFF']
  };
  autoScale = true;
  animations = true;
  gradient = true;
  view = [700, 300];

  groupASession$: Observable<any>;
  groupBSession$: Observable<any>;

  constructor(private store: Store<State>) {}

  ngOnInit() {
    this.groupASession$ = this.store.select(
      state => state.admin.groupASessionCounts
    );

    this.groupBSession$ = this.store.select(
      state => state.admin.groupBSessionCounts
    );
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/admin/bottom-panel/bottom-panel.component.ts